import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ui-btn-hint',
  templateUrl: './ui-btn-hint.component.html',
})
export class UiBtnHintComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
